// Third Party
import React from 'react';

// Components
import { Button } from '../../../../components/buttons';
import { GenericEmptyState } from '../../../../components/misc';
import BMOGifChart from '../../../../components/bmo-gif/charts/BMOGifChart';
import LegacyBMOGifLegend from '@/views/components/bmo-gif/charts/legacy/LegacyBMOGifLegend';

// Utils
import { BMOi18n } from '@/utils/bmo-gif/constants';
import { scenarioHasWithdrawal } from '@/utils/bmo-gif';
import BMOGIFScenario from '@/types/bmo-gif/bmo-gif-scenario';
import BMOGIFPortfolio from '@/types/bmo-gif/bmo-gif-portfolio';

type StateProps = {
  scenario?: BMOGIFScenario;
  locale: string;
  portfolio: BMOGIFPortfolio;
};

type DispatchProps = {
  onEditDetails: () => void;
};

type Props = StateProps & DispatchProps;

class LegacyBMOGIFGraphView extends React.Component<Props> {
  renderActionButton = () => {
    const { locale } = this.props;

    return (
      <Button onClick={this.props.onEditDetails} className="edit-details" icon="pencil">
        <span>{BMOi18n[locale].GIF_GRAPH.EDIT_DETAILS}</span>
      </Button>
    );
  };

  renderContent = () => {
    const { scenario, locale, portfolio } = this.props;

    if (!scenario) {
      return <GenericEmptyState header={BMOi18n[locale].GIF_GRAPH.EMPTY_STATE_TITLE} body={BMOi18n[locale].GIF_GRAPH.EMPTY_STATE_MESSAGE} dark />;
    }

    return (
      <div className="chart-container">
        <BMOGifChart scenario={scenario} dark locale={locale} planOption={portfolio.planOption} tooltipDisclaimer />
      </div>
    );
  };

  render() {
    const { scenario, locale, portfolio } = this.props;

    return (
      <div className="bmo-gif-graph-view">
        <div className="graph-header">
          {scenario && (
            <LegacyBMOGifLegend
              locale={locale}
              dark
              withdrawal={scenario && !scenarioHasWithdrawal(scenario)}
              deposit={scenario.deposit.amount === 0}
              tooltipDisclaimer
              planOption={portfolio.planOption}
            />
          )}

          {this.renderActionButton()}
        </div>

        {this.renderContent()}
      </div>
    );
  }
}

export default LegacyBMOGIFGraphView;
